<template>
  <button type="submit" :disabled="disabled" @click="callback($event)">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    disabled: Boolean,
  },
  methods: {
    callback(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  &_primary {
    @apply block bg-pink-main text-white px-8 py-3 cursor-pointer font-bold;
    border-radius: 100px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    &:hover {
      @apply bg-pink-dark-main;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    }
    @media screen and (min-width: 768px) {
      @apply text-2xl px-12 py-4;
    }
    &:disabled{
      color: #e8e8e8 !important;
      background-color: #bababa !important;
      pointer-events: none !important;
    }
  }
  &_secondary {
    @apply block mx-auto px-8 py-3 bg-blue text-white cursor-pointer font-bold;
    border-radius: 100px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    &:hover {
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    }
    @media screen and (min-width: 768px) {
      @apply text-2xl px-12 py-4;
    }
    &:disabled{
      color: #e8e8e8 !important;
      background-color: #bababa !important;
      pointer-events: none !important;
    }
  }
  &-xl {
    @media screen and (min-width: 768px) {
      @apply text-xl;
    }
  }
  &__inactive{
    color: #e8e8e8;
    background-color: #bababa;
    pointer-events: none;
  }
}
</style>
